import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { createForm } from 'rc-form';
import { connect } from 'react-redux';
import { Switch, Redirect } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';

import { selectFeatureFlags } from 'yeself-client-common/featureFlags/FeatureFlagsSelector';

import PrivateRoute from 'yeself-client-common/security/components/PrivateRoute';

import { selectApplicationSettings } from 'Console/data/applicationDetail/settings/SettingsSelector';

import NavSider from 'Console/components/applications/detail/contextHelp/NavSider';
import Breadcrumb from 'Console/components/common/Breadcrumb';
import CompositionContainer from 'Console/components/applications/detail/contextHelp/composition/CompositionContainer';
import Settings from 'Console/components/applications/detail/contextHelp/settings/Settings';

import { fetchApplicationGuides } from 'Console/data/applicationDetail/guides/actions';
import { ROUTES } from 'Console/constants/routes';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        padding: '0 24px',
    },
    navLink: {
        textDecoration: 'none',
    },
    paper: {
        padding: theme.typography.pxToRem(16),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    navList: {
        [theme.breakpoints.up('lg')]: {
            maxWidth: '18%',
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: '15%',
        },
        [theme.breakpoints.down('md')]: {
            marginBottom: '20px',
        },
    },
    formBox: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '83%',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '82%',
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: '85%',
        },
    },
});

const ApplicationContextHelp = ({
    classes,
    intl,
    hasGlobalRoutePrefix = false,
    form,
    match,
    applicationDetail: { data },
    fetchApplicationGuides,
    featureFlags,
}) => {
    useEffect(() => {
        const { appId } = match.params;
        if (appId) {
            fetchApplicationGuides(appId);
        }
    }, [fetchApplicationGuides, match.params]);

    const routePrefix = hasGlobalRoutePrefix ? ROUTES.CONTEXT_HELP : match.url;

    return (
        <Grid container className={classes.root}>
            <Switch>
                <>
                    <Grid container spacing={24} justify="center" alignItems="center">
                        <Grid item xs={12} md={hasGlobalRoutePrefix ? 10 : 12}>
                            <Breadcrumb
                                paths={[
                                    {
                                        to: ROUTES.APPLICATIONS,
                                        text: intl.formatMessage({ id: 'Navigation.applications' }),
                                    },
                                    {
                                        text: data.name,
                                    },
                                ]}
                            />
                            <Typography variant="h6">
                                {intl.formatMessage({ id: 'ContextHelp.title' })}
                            </Typography>
                        </Grid>
                        <Grid item container xs={12} md={hasGlobalRoutePrefix ? 10 : 12}>
                            <Grid item xs={12} md={2} className={classes.navList}>
                                <NavSider
                                    featureFlags={featureFlags}
                                    intl={intl}
                                    routePrefix={routePrefix}
                                />
                            </Grid>

                            <Grid item xs={12} className={classes.formBox}>
                                <Switch>
                                    <PrivateRoute
                                        path={`${routePrefix}${ROUTES.CONTEXT_HELP_COMPOSITION}`}
                                        component={CompositionContainer}
                                        form={form}
                                    />

                                    <PrivateRoute
                                        path={`${routePrefix}${ROUTES.CONTEXT_HELP_SETTINGS}`}
                                        component={Settings}
                                        form={form}
                                    />

                                    <Redirect
                                        from={match.url}
                                        to={`${routePrefix}${ROUTES.CONTEXT_HELP_SETTINGS}`}
                                    />
                                </Switch>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            </Switch>
        </Grid>
    );
};

export default connect(
    (state) => ({
        applicationDetail: selectApplicationSettings(state),
        featureFlags: selectFeatureFlags(state),
    }),
    { fetchApplicationGuides }
)(withStyles(styles)(injectIntl(createForm()(ApplicationContextHelp))));
